module.exports = __webpack_public_path__ + "static/media/country_an.1f45f8b8.webp";